import { v4 as uuidv4 } from "uuid";
import checkBulletImage from "@circle-react-shared/BuilderUI/Assets/icons/check_bullet.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH2Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextTransformOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { primaryBlockDefaultStyles } from "../../constants";
import placeholderImage from "./homepage_block_3_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProfessionalNetworkHomepageBlock3",
  props: {
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "About us",
          paragraphStyle: "p3",
          styles: {
            textTransform: getTextTransformOptions("uppercase"),
          },
        }),
        createH2Block({
          text: "Where professional vision becomes a shared path",
        }),
        createPBlock({
          text: "Growth Network exists for educators, facilitators, and independent leaders who bring intention to their teaching—and structure to their growth. Our model supports those who want to lead with clarity, design with rigor, and scale within a trusted network of peers committed to excellence and impact.",
        }),
        createUlBlock({
          items: [
            {
              text: "Certified Executive Coach (ICF)",
              placeholder: checkBulletImage,
            },
            {
              text: "10,000+ coaching hours with professionals & executives",
              placeholder: checkBulletImage,
            },
            {
              text: "Founder of the Clarity Leadership Collective",
              placeholder: checkBulletImage,
            },
            {
              text: "Former Director of Operations at Fortune 500",
              placeholder: checkBulletImage,
            },
          ],
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
        }),
        padding: getPaddingOptions({
          defaultValue: primaryBlockDefaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
        }),
      },
    },
  },
};
